import React from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBBadge,
  MDBListGroup,
  MDBListGroupItem,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";

import { doFetch, doFetchJson } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { getApp, getAppPermisions } from "Projects/CC_cubi_clan_project/Utils/PermissionManager";
import { mfmThumbUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";

import BatchesModal from "./BatchesModal";
import CustomersModal from "./CustomersModal";
import FuncionFormModal from "./FuncionFormModal";
import SesionFormModal from "./SesionFormModal";
import VenueList from "./VenueList";

import "./TicketsSection.css";

const toAbsUrl = (url) => /^https?:\/\//i.test(url) ? url : 'https://' + url;

/**
 * TicketsSection — Módulo de gestión de entradas (fase 1).
 *
 * Lista transversal de funciones (Representaciones) con sus sesiones,
 * filtrables por obra y por visibilidad de funciones pasadas. Es el
 * punto de entrada para los flujos futuros: ver lotes de entradas,
 * crear/editar lotes, registrar ventas, etc.
 *
 * Endpoint: GET /api/teansari/getFunciones?idProyecto=&includePast=
 * Permiso requerido: TEAN.TICKET_MANAGE (o TICKET_SELL en futuras fases).
 */
class TicketsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      funciones: [],
      loaded: false,
      // filtros
      idProyectoFilter: "",
      includePast: false,
      // catálogo de proyectos para el dropdown
      proyectos: [],
      // vista activa: 'funciones' | 'salas'
      view: "funciones",
      // sesión seleccionada para abrir el modal de lotes
      batchesSesion: null,
      batchesFuncion: null,
      // permisos del usuario sobre TEAN (para gobernar UI manager vs vendedor)
      canManage: false,
      canSell: false,
      // modal de clientes
      customersOpen: false,
      // modal crear/editar función
      funcionFormOpen: false,
      funcionFormData: null, // null = nueva, objeto = editar
      // modal crear/editar sesión
      sesionFormOpen: false,
      sesionFormFuncionId: null,
      sesionFormFuncionName: null,
      sesionFormData: null, // null = nueva, objeto = editar
      // confirmación de borrado
      deleteConfirmFuncionId: null,
      deleteConfirmSesionId: null,
    };
  }

  openBatches = (sesion, funcion) => {
    this.setState({ batchesSesion: sesion, batchesFuncion: funcion });
  };

  closeBatches = () => {
    this.setState({ batchesSesion: null, batchesFuncion: null });
  };

  openCustomers = () => this.setState({ customersOpen: true });
  closeCustomers = () => this.setState({ customersOpen: false });

  // --- Función CRUD handlers ---

  openNuevaFuncion = () => this.setState({ funcionFormOpen: true, funcionFormData: null });

  openEditarFuncion = (f) => this.setState({ funcionFormOpen: true, funcionFormData: f });

  closeFuncionForm = () => this.setState({ funcionFormOpen: false, funcionFormData: null });

  handleFuncionSaved = () => {
    this.closeFuncionForm();
    this.loadFunciones();
  };

  confirmDeleteFuncion = (id) => this.setState({ deleteConfirmFuncionId: id });
  cancelDeleteFuncion = () => this.setState({ deleteConfirmFuncionId: null });

  handleDeleteFuncion = () => {
    const { deleteConfirmFuncionId } = this.state;
    if (!deleteConfirmFuncionId) return;
    this.setState({ deleteConfirmFuncionId: null });
    doFetchJson("TEAN", "deleteFuncion?id=" + deleteConfirmFuncionId, { method: "DELETE" })
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          toast.show({ message: "Función eliminada", type: "success" });
          this.loadFunciones();
        } else if (json && json.STATE === "CONFLICT") {
          toast.show({
            message: json.MESSAGE || "No se puede eliminar: tiene lotes de entradas",
            type: "warning",
          });
        } else {
          toast.show({
            message: (json && json.MESSAGE) || "Error al eliminar la función",
            type: "danger",
          });
        }
      })
      .catch(() => toast.show({ message: "Error de red al eliminar la función", type: "danger" }));
  };

  // --- Sesión CRUD handlers ---

  openNuevaSesion = (f) =>
    this.setState({
      sesionFormOpen: true,
      sesionFormFuncionId: f.idRepresentacion,
      sesionFormFuncionName: f.name,
      sesionFormData: null,
    });

  openEditarSesion = (s, f) =>
    this.setState({
      sesionFormOpen: true,
      sesionFormFuncionId: f.idRepresentacion,
      sesionFormFuncionName: f.name,
      sesionFormData: s,
    });

  closeSesionForm = () =>
    this.setState({ sesionFormOpen: false, sesionFormFuncionId: null, sesionFormData: null });

  handleSesionSaved = () => {
    this.closeSesionForm();
    this.loadFunciones();
  };

  confirmDeleteSesion = (id) => this.setState({ deleteConfirmSesionId: id });
  cancelDeleteSesion = () => this.setState({ deleteConfirmSesionId: null });

  handleDeleteSesion = () => {
    const { deleteConfirmSesionId } = this.state;
    if (!deleteConfirmSesionId) return;
    this.setState({ deleteConfirmSesionId: null });
    doFetchJson("TEAN", "deleteSesion?id=" + deleteConfirmSesionId, { method: "DELETE" })
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          toast.show({ message: "Sesión eliminada", type: "success" });
          this.loadFunciones();
        } else if (json && json.STATE === "CONFLICT") {
          toast.show({
            message: json.MESSAGE || "No se puede eliminar: tiene lotes de entradas",
            type: "warning",
          });
        } else {
          toast.show({
            message: (json && json.MESSAGE) || "Error al eliminar la sesión",
            type: "danger",
          });
        }
      })
      .catch(() => toast.show({ message: "Error de red al eliminar la sesión", type: "danger" }));
  };

  componentDidMount() {
    this.loadPermissions();
  }

  loadPermissions = async () => {
    try {
      const app = await getApp("TEAN", () => {});
      if (!app) {
        this.loadProyectos();
        this.loadFunciones();
        return;
      }
      const perms = await getAppPermisions(app, () => {});
      const names = Array.isArray(perms)
        ? perms.map((p) => p && p.nombre).filter(Boolean)
        : [];
      const canManage =
        names.includes("TICKET_MANAGE") ||
        names.includes("APP_ADMIN") ||
        names.includes("APP_MANAGE");
      const canSell = names.includes("TICKET_SELL");
      this.setState({ canManage, canSell }, () => {
        if (!canManage && canSell) {
          this.loadMyBatches();
        } else {
          this.loadProyectos();
          this.loadFunciones();
        }
      });
    } catch (e) {
      console.error("Error cargando permisos TEAN:", e);
      this.loadProyectos();
      this.loadFunciones();
    }
  };

  loadProyectos = () => {
    doFetch("TEAN", "getProyectosLite")
      .then((res) => res.json())
      .then((json) => {
        if (json.STATE === "SUCCESS" && Array.isArray(json.DATA)) {
          this.setState({
            proyectos: json.DATA
              .map((p) => ({ id: p.idProyecto, title: p.title }))
              .sort((a, b) => (a.title || "").localeCompare(b.title || "")),
          });
        }
      })
      .catch((err) => {
        console.error("Error cargando proyectos:", err);
      });
  };

  loadFunciones = () => {
    if (this.props.onLoading) this.props.onLoading(true);
    this.setState({ loaded: false });

    const { idProyectoFilter, includePast } = this.state;
    const params = [];
    if (idProyectoFilter) params.push("idProyecto=" + encodeURIComponent(idProyectoFilter));
    params.push("includePast=" + (includePast ? "true" : "false"));
    const qs = params.length ? "?" + params.join("&") : "";

    doFetch("TEAN", "getFunciones" + qs)
      .then((res) => res.json())
      .then((json) => {
        if (json.STATE === "SUCCESS") {
          this.setState({ funciones: json.DATA || [], loaded: true });
        } else {
          toast.show({
            message: json.MESSAGE || "No se pudieron recuperar las funciones",
            type: "warning",
          });
          this.setState({ funciones: [], loaded: true });
        }
      })
      .catch((err) => {
        console.error("Error cargando funciones:", err);
        toast.show({ message: "Error al cargar las funciones", type: "danger" });
        this.setState({ funciones: [], loaded: true });
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  };

  /**
   * Modo vendedor puro (TICKET_SELL sin TICKET_MANAGE).
   * Carga todos los lotes asignados al usuario y los agrupa por función,
   * construyendo una estructura compatible con renderFuncionCard.
   */
  loadMyBatches = () => {
    if (this.props.onLoading) this.props.onLoading(true);
    this.setState({ loaded: false });
    doFetchJson("TEAN", "getMyAssignedBatches")
      .then((json) => {
        if (json && json.STATE === "SUCCESS") {
          const batches = Array.isArray(json.DATA) ? json.DATA : [];
          // Agrupar por idRepresentacion
          const byFunc = {};
          batches.forEach((b) => {
            const fid = b.idRepresentacion;
            if (!byFunc[fid]) {
              byFunc[fid] = {
                idRepresentacion: fid,
                name: b.funcionName || "Función",
                projectName: null,
                date: null,
                address: null,
                status: null,
                imageUuid: null,
                sesiones: {},
              };
            }
            const sid = b.idRepresentacionFecha;
            if (sid && !byFunc[fid].sesiones[sid]) {
              byFunc[fid].sesiones[sid] = {
                idRepresentacionFecha: sid,
                startDatetime: b.sessionStart,
              };
            }
          });
          const funciones = Object.values(byFunc).map((f) => ({
            ...f,
            sesiones: Object.values(f.sesiones).sort(
              (a, b) => new Date(a.startDatetime) - new Date(b.startDatetime)
            ),
          }));
          this.setState({ funciones, loaded: true });
        } else {
          this.setState({ funciones: [], loaded: true });
        }
      })
      .catch(() => {
        toast.show({ message: "Error al cargar los lotes asignados", type: "danger" });
        this.setState({ funciones: [], loaded: true });
      })
      .finally(() => {
        if (this.props.onLoading) this.props.onLoading(false);
      });
  };

  handleProyectoChange = (event) => {    this.setState({ idProyectoFilter: event.target.value }, this.loadFunciones);
  };

  handleIncludePastToggle = () => {
    this.setState(
      (prev) => ({ includePast: !prev.includePast }),
      this.loadFunciones
    );
  };

  formatDate = (iso) => {
    if (!iso) return "Sin fecha";
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString("es-ES", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return iso;
    }
  };


  statusBadge = (status) => {
    const s = (status || "DRAFT").toUpperCase();
    let color = "secondary";
    let label = s;
    switch (s) {
      case "DRAFT":
        color = "secondary";
        label = "Borrador";
        break;
      case "PUBLISHED":
        color = "info";
        label = "Publicada";
        break;
      case "ON_SALE":
        color = "success";
        label = "En venta";
        break;
      case "CLOSED":
        color = "dark";
        label = "Cerrada";
        break;
      case "CANCELLED":
        color = "danger";
        label = "Cancelada";
        break;
      default:
        break;
    }
    return (
      <MDBBadge color={color} className="ms-2">
        {label}
      </MDBBadge>
    );
  };

  /**
   * Ordena funciones por fecha de inicio ASC (la más próxima primero).
   * "Fecha de inicio" = primera sesión futura (earliestFuture).
   * Funciones sin sesiones futuras van al final, ordenadas DESC por última sesión.
   * nextId = la función con la sesión futura más inmediata (badge "Próxima función").
   */
  sortFunciones = (funciones) => {
    const now = Date.now();
    const withKey = funciones.map((f) => {
      const times = (f.sesiones || [])
        .filter((s) => s.startDatetime)
        .map((s) => new Date(s.startDatetime).getTime());
      const futureTimes = times.filter((t) => t > now);
      const pastTimes   = times.filter((t) => t <= now);
      return {
        f,
        earliestFuture: futureTimes.length > 0 ? Math.min(...futureTimes) : null,
        latestPast:     pastTimes.length   > 0 ? Math.max(...pastTimes)   : null,
      };
    });

    withKey.sort((a, b) => {
      // 1. Funciones con sesión futura primero (ASC por la más próxima)
      const aHasFuture = a.earliestFuture !== null;
      const bHasFuture = b.earliestFuture !== null;
      if (aHasFuture && bHasFuture) return a.earliestFuture - b.earliestFuture;
      if (aHasFuture) return -1;
      if (bHasFuture) return 1;
      // 2. Sesiones pasadas: DESC por la más reciente (igual que dentro de cada tarjeta)
      const aHasPast = a.latestPast !== null;
      const bHasPast = b.latestPast !== null;
      if (aHasPast && bHasPast) return b.latestPast - a.latestPast;
      if (aHasPast) return -1;
      if (bHasPast) return 1;
      // 3. Sin sesiones: mantener el orden que devuelve el backend
      return 0;
    });

    const sorted = withKey.map((x) => x.f);
    const nextEntry = withKey
      .filter((x) => x.earliestFuture !== null)
      .reduce((min, x) => (min === null || x.earliestFuture < min.earliestFuture ? x : min), null);
    const nextId = nextEntry ? nextEntry.f.idRepresentacion : null;
    return { sorted, nextId };
  };

  renderFuncionCard = (f, isNext = false) => {
    const now = new Date().toISOString();
    const sesiones = (Array.isArray(f.sesiones) ? [...f.sesiones] : [])
      .sort((a, b) => {
        const aFuture = a.startDatetime && a.startDatetime > now;
        const bFuture = b.startDatetime && b.startDatetime > now;
        // Futuras primero; futuras ASC, pasadas DESC
        if (aFuture && !bFuture) return -1;
        if (!aFuture && bFuture) return 1;
        if (!a.startDatetime && !b.startDatetime) return 0;
        if (!a.startDatetime) return 1;
        if (!b.startDatetime) return -1;
        return aFuture
          ? a.startDatetime.localeCompare(b.startDatetime)   // futuras: ASC
          : b.startDatetime.localeCompare(a.startDatetime);  // pasadas: DESC
      });
    const thumb = f.imageUuid ? mfmThumbUrl(f.imageUuid) : null;
    const { canManage } = this.state;

    return (
      <MDBCol size="12" lg="6" key={f.idRepresentacion} className="mb-3">
        <MDBCard className={`tickets-funcion-card h-100${isNext ? " tickets-funcion-card--next" : ""}`}>
          <MDBCardBody>
            {isNext && (
              <div className="tickets-proxima-banner">
                <MDBIcon far icon="clock" className="me-1" />
                Próxima función
              </div>
            )}
            <div className="d-flex">
              {thumb && (
                <div className="tickets-funcion-thumb me-3">
                  <img src={thumb} alt={f.name} />
                </div>
              )}
              <div className="flex-grow-1">
                <div className="d-flex align-items-start justify-content-between">
                  <MDBCardTitle className="mb-1 flex-grow-1">
                    {f.name}
                    {this.statusBadge(f.status)}
                  </MDBCardTitle>
                  {canManage && (
                    <MDBBtnGroup className="ms-2 flex-shrink-0">
                      <MDBBtn
                        size="sm"
                        color="light"
                        onClick={() => this.openEditarFuncion(f)}
                        title="Editar función"
                      >
                        <MDBIcon fas icon="pencil-alt" />
                      </MDBBtn>
                      <MDBBtn
                        size="sm"
                        color="danger"
                        onClick={() => this.confirmDeleteFuncion(f.idRepresentacion)}
                        title="Eliminar función"
                      >
                        <MDBIcon fas icon="trash" />
                      </MDBBtn>
                    </MDBBtnGroup>
                  )}
                </div>
                <div className="text-muted small mb-1">
                  <MDBIcon fas icon="theater-masks" className="me-1" />
                  {f.projectName || "—"}
                </div>
                {f.address && (
                  <div className="text-muted small mb-1">
                    <MDBIcon fas icon="map-marker-alt" className="me-1" />
                    {f.address}
                  </div>
                )}
                {f.enlaceUrl && (
                  <div className="small mb-1">
                    <a href={toAbsUrl(f.enlaceUrl)} target="_blank" rel="noopener noreferrer" className="tickets-funcion-enlace">
                      <MDBIcon fas icon="external-link-alt" className="me-1" />
                      Ir al sitio
                    </a>
                  </div>
                )}
              </div>
            </div>

            {sesiones.length > 0 ? (
              <MDBListGroup light small className="mt-2 tickets-sesiones-list">
                {sesiones.map((s) => (
                  <MDBListGroupItem
                    key={s.idRepresentacionFecha}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <MDBIcon far icon="clock" className="me-1 text-secondary" />
                      {this.formatDate(s.startDatetime)}
                    </span>
                    <MDBBtnGroup>
                      <MDBBtn
                        size="sm"
                        color="light"
                        onClick={() => this.openBatches(s, f)}
                        title="Ver lotes de entradas"
                      >
                        <MDBIcon fas icon="ticket-alt" className="me-1" />
                        Lotes
                      </MDBBtn>
                      {canManage && (
                        <>
                          <MDBBtn
                            size="sm"
                            color="light"
                            onClick={() => this.openEditarSesion(s, f)}
                            title="Editar sesión"
                          >
                            <MDBIcon fas icon="pencil-alt" />
                          </MDBBtn>
                          <MDBBtn
                            size="sm"
                            color="danger"
                            onClick={() => this.confirmDeleteSesion(s.idRepresentacionFecha)}
                            title="Eliminar sesión"
                          >
                            <MDBIcon fas icon="trash" />
                          </MDBBtn>
                        </>
                      )}
                    </MDBBtnGroup>
                  </MDBListGroupItem>
                ))}
              </MDBListGroup>
            ) : (
              <div className="text-muted fst-italic small mt-2">
                Sin sesiones programadas.
              </div>
            )}

            {canManage && (
              <div className="mt-2">
                <MDBBtn
                  size="sm"
                  color="light"
                  className="w-100"
                  onClick={() => this.openNuevaSesion(f)}
                >
                  <MDBIcon fas icon="plus" className="me-1" />
                  Añadir sesión
                </MDBBtn>
              </div>
            )}
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    );
  };

  render() {
    const {
      funciones, loaded, idProyectoFilter, includePast, proyectos,
      canManage, canSell, view,
      funcionFormOpen, funcionFormData,
      sesionFormOpen, sesionFormFuncionId, sesionFormFuncionName, sesionFormData,
      deleteConfirmFuncionId, deleteConfirmSesionId,
    } = this.state;
    const isSellOnly = !canManage && canSell;

    return (
      <MDBContainer className="tickets-section py-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
          <h3 className="mb-0">
            <MDBIcon fas icon="ticket-alt" className="me-2" />
            {isSellOnly ? "Mis entradas" : "Gestión de entradas"}
          </h3>
          <div className="d-flex gap-2 flex-wrap">
            {canManage && view === "funciones" && (
              <MDBBtn
                color="primary"
                size="sm"
                onClick={this.openNuevaFuncion}
              >
                <MDBIcon fas icon="plus" className="me-1" />
                Nueva función
              </MDBBtn>
            )}
            {canManage && (
              <MDBBtn
                color={view === "salas" ? "primary" : "light"}
                size="sm"
                onClick={() => this.setState({ view: view === "salas" ? "funciones" : "salas" })}
                title={view === "salas" ? "Ver funciones" : "Gestionar salas"}
              >
                <MDBIcon fas icon={view === "salas" ? "ticket-alt" : "building"} className="me-1" />
                {view === "salas" ? "Funciones" : "Salas"}
              </MDBBtn>
            )}
            {canManage && view === "funciones" && (
              <MDBBtn
                color="light"
                size="sm"
                onClick={this.openCustomers}
                title="Gestionar clientes"
              >
                <MDBIcon fas icon="users" className="me-1" />
                Clientes
              </MDBBtn>
            )}
            {view === "funciones" && (
              <MDBBtn
                color="light"
                size="sm"
                onClick={isSellOnly ? this.loadMyBatches : this.loadFunciones}
                title="Refrescar listado"
              >
                <MDBIcon fas icon="sync-alt" className="me-1" />
                Refrescar
              </MDBBtn>
            )}
          </div>
        </div>

        {/* Vista de salas */}
        {view === "salas" && (
          <VenueList />
        )}
        {view === "salas" && <div style={{ display: "none" }}>{/* resto de renders bloqueado */}</div>}

        {view === "funciones" && !isSellOnly && (
          <MDBCard className="mb-3">
            <MDBCardBody className="py-2">
              <MDBRow className="align-items-center g-2">
                <MDBCol size="12" md="6" lg="5">
                  <label className="form-label small text-muted mb-1">Obra</label>
                  <select
                    className="form-select form-select-sm"
                    value={idProyectoFilter}
                    onChange={this.handleProyectoChange}
                  >
                    <option value="">Todas las obras</option>
                    {proyectos.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.title}
                      </option>
                    ))}
                  </select>
                </MDBCol>
                <MDBCol size="12" md="6" lg="4">
                  <div className="form-check mt-md-4 mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="tickets-include-past"
                      checked={includePast}
                      onChange={this.handleIncludePastToggle}
                    />
                    <label className="form-check-label" htmlFor="tickets-include-past">
                      Incluir funciones pasadas
                    </label>
                  </div>
                </MDBCol>
                <MDBCol size="12" lg="3" className="text-lg-end">
                  <span className="text-muted small">
                    {loaded
                      ? `${funciones.length} función(es)`
                      : "Cargando..."}
                  </span>
                </MDBCol>
              </MDBRow>
            </MDBCardBody>
          </MDBCard>
        )}

        {view === "funciones" && loaded && funciones.length === 0 ? (
          <div className="text-center text-muted py-5">
            <MDBIcon fas icon="inbox" size="2x" className="mb-2 d-block" />
            No hay funciones que mostrar con los filtros actuales.
          </div>
        ) : view === "funciones" ? (() => {
          const { sorted, nextId } = this.sortFunciones(funciones);
          return <MDBRow>{sorted.map((f) => this.renderFuncionCard(f, f.idRepresentacion === nextId))}</MDBRow>;
        })() : null}

        {/* Modales de tickets */}
        <BatchesModal
          show={!!this.state.batchesSesion}
          sesion={this.state.batchesSesion}
          funcion={this.state.batchesFuncion}
          funcionName={this.state.batchesFuncion ? this.state.batchesFuncion.name : null}
          canManage={this.state.canManage}
          canSell={this.state.canSell}
          onClose={this.closeBatches}
        />

        <CustomersModal
          show={this.state.customersOpen}
          onClose={this.closeCustomers}
        />

        {/* Modales de gestión de funciones */}
        <FuncionFormModal
          show={funcionFormOpen}
          funcion={funcionFormData}
          proyectos={proyectos}
          onClose={this.closeFuncionForm}
          onSaved={this.handleFuncionSaved}
        />

        <SesionFormModal
          show={sesionFormOpen}
          sesion={sesionFormData}
          idRepresentacion={sesionFormFuncionId}
          funcionName={sesionFormFuncionName}
          onClose={this.closeSesionForm}
          onSaved={this.handleSesionSaved}
        />

        {/* Confirmación de borrado de función */}
        {deleteConfirmFuncionId && (
          <MDBModal
            show={!!deleteConfirmFuncionId}
            onHide={this.cancelDeleteFuncion}
            tabIndex="-1"
          >
            <MDBModalDialog centered>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>
                    <MDBIcon fas icon="exclamation-triangle" className="me-2 text-danger" />
                    Eliminar función
                  </MDBModalTitle>
                  <MDBBtn className="btn-close" color="none" onClick={this.cancelDeleteFuncion} />
                </MDBModalHeader>
                <MDBModalBody>
                  ¿Seguro que quieres eliminar esta función? Se eliminarán también todas sus sesiones.
                  Esta acción no se puede deshacer.
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn color="secondary" onClick={this.cancelDeleteFuncion}>
                    Cancelar
                  </MDBBtn>
                  <MDBBtn color="danger" onClick={this.handleDeleteFuncion}>
                    <MDBIcon fas icon="trash" className="me-1" />
                    Eliminar
                  </MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        )}

        {/* Confirmación de borrado de sesión */}
        {deleteConfirmSesionId && (
          <MDBModal
            show={!!deleteConfirmSesionId}
            onHide={this.cancelDeleteSesion}
            tabIndex="-1"
          >
            <MDBModalDialog centered>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>
                    <MDBIcon fas icon="exclamation-triangle" className="me-2 text-danger" />
                    Eliminar sesión
                  </MDBModalTitle>
                  <MDBBtn className="btn-close" color="none" onClick={this.cancelDeleteSesion} />
                </MDBModalHeader>
                <MDBModalBody>
                  ¿Seguro que quieres eliminar esta sesión?
                  Si tiene lotes de entradas, no podrá eliminarse.
                </MDBModalBody>
                <MDBModalFooter>
                  <MDBBtn color="secondary" onClick={this.cancelDeleteSesion}>
                    Cancelar
                  </MDBBtn>
                  <MDBBtn color="danger" onClick={this.handleDeleteSesion}>
                    <MDBIcon fas icon="trash" className="me-1" />
                    Eliminar
                  </MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        )}
      </MDBContainer>
    );
  }
}

export default TicketsSection;
